var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":this.$root.isLoading,"loader":"dots","background-color":"#000","color":"#fff","opacity":1},on:{"update:active":function($event){return _vm.$set(this.$root, "isLoading", $event)}}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }